var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptionsHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 21,
    viewBox: "0 0 5 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_703",
    "data-name": "Group 703",
    transform: "translate(-1293 -381)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1293 381)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1293 389)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    "data-name": "Ellipse 101",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1293 397)",
    fill: "#c1c1c1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionsHorizontal);
export default __webpack_public_path__ + "static/media/options-horizontal.27d87cc5596b1214224150dfa87ceade.svg";
export { ForwardRef as ReactComponent };